import React from 'react';

const EndPage = React.forwardRef((props, ref) => {
  return (
    <div ref={ref} className="book-page" data-density="hard">
      <div className="absolute inset-0 bg-gradient-to-br from-rose-800 via-rose-900 to-gray-900 flex flex-col items-center justify-center px-6 sm:px-8 text-center overflow-hidden">
        {/* Decorative circle */}
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-white/5" />

        <div className="relative z-10">
          <div className="text-4xl mb-4">{'\u2728'}</div>

          <h2
            className="text-xl sm:text-2xl font-bold text-white mb-2"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            Your Story Awaits
          </h2>

          <p
            className="text-sm text-rose-200/80 mb-6 max-w-[200px] mx-auto leading-relaxed"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Turn your own chats into a beautiful keepsake book
          </p>

          <a
            href="/type"
            className="sbv-endpage-cta inline-flex items-center gap-2 bg-white text-rose-800 font-semibold text-sm px-6 py-2.5 rounded-full hover:bg-rose-50 transition-colors shadow-lg cursor-pointer"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            Create My Book
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>

          <p
            className="text-[10px] text-rose-300/60 mt-4"
            style={{ fontFamily: "'Space Mono', monospace" }}
          >
            It only takes a few minutes
          </p>
        </div>
      </div>
    </div>
  );
});

EndPage.displayName = 'EndPage';
export default EndPage;
